module.exports = __webpack_public_path__ + "img/eseminar.68e9c09.png";